'use es6';

import { List } from 'immutable';
import Lists from '../models/Lists';
import { RECEIVED_LISTS, REQUESTED_LISTS_FAILED, REQUESTED_LISTS, RECEIVED_SPECIFIC_LISTS, REQUESTED_SPECIFIC_LISTS_FAILED, REQUESTED_SPECIFIC_LISTS, RECEIVED_STATIC_LISTS, REQUESTED_STATIC_LISTS_FAILED, REQUESTED_STATIC_LISTS, UPDATE_LISTS_FOR_CONTENT } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
function mergeNeededListData(updatedSelectedLists, oldNeededListData, allLists) {
  return updatedSelectedLists.reduce((acc, listId) => {
    if (!acc.find(list => list.get('listId') === listId)) {
      const findCurrentList = list => list.get('listId') === listId;
      const listData = allLists.find(findCurrentList) || oldNeededListData.find(findCurrentList);
      if (listData) {
        return acc.push(listData);
      }
    }
    return acc;
  }, List());
}
export default ((state = new Lists(), action) => {
  switch (action.type) {
    case REQUESTED_LISTS:
      return state.set('listsStatus', RequestStatus.PENDING);
    case RECEIVED_LISTS:
      {
        const {
          lists,
          listsStatus
        } = action.payload.lists;
        return state.merge({
          lists,
          listsStatus
        });
      }
    case REQUESTED_LISTS_FAILED:
      return state.set('listsStatus', RequestStatus.FAILED);
    case REQUESTED_SPECIFIC_LISTS:
      return state.set('listsForContentStatus', RequestStatus.PENDING);
    case RECEIVED_SPECIFIC_LISTS:
      {
        const {
          listsForContent,
          listsForContentStatus
        } = action.payload.lists;
        return state.merge({
          listsForContent,
          listsForContentStatus
        });
      }
    case REQUESTED_SPECIFIC_LISTS_FAILED:
      return state.set('listsForContentStatus', RequestStatus.FAILED);
    case REQUESTED_STATIC_LISTS:
      return state.set('staticListsStatus', RequestStatus.PENDING);
    case RECEIVED_STATIC_LISTS:
      {
        const {
          staticLists,
          staticListsStatus
        } = action.payload.lists;
        return state.merge({
          staticLists,
          staticListsStatus
        });
      }
    case REQUESTED_STATIC_LISTS_FAILED:
      return state.set('staticListsStatus', RequestStatus.FAILED);
    case UPDATE_LISTS_FOR_CONTENT:
      return state.set('listsForContent', mergeNeededListData(action.payload.updatedSelectedLists, state.listsForContent, state.lists));
    default:
      return state;
  }
});